import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useIntl } from 'react-intl';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { ExternalLinkInput } from 'components/content/ExternalLinkInput';
import { generateClickableUrl, generateDisplayableUrl } from 'libs/content/utils';
import { EditLinkToolbar } from '../EditLinkToolbar';
import { LinkURL } from './ExternalLink.style';

var ExternalLink = function ExternalLink(_ref) {
  var editorRef = _ref.editorRef,
      editorState = _ref.editorState,
      entityKey = _ref.entityKey,
      removeEntity = _ref.removeEntity,
      updateEntity = _ref.updateEntity;
  var intl = useIntl();

  var _useGetBlockData = useGetBlockData(editorState, undefined, entityKey),
      entityData = _useGetBlockData.entityData;

  if (entityData.editLink !== true) {
    return null;
  }

  return __jsx(EditLinkToolbar, {
    title: intl.formatMessage({
      id: 'link.external.title'
    }),
    onDelete: function onDelete() {
      return removeEntity(entityKey);
    },
    updateEntity: updateEntity,
    entityKey: entityKey,
    editorRef: editorRef,
    editorState: editorState,
    editComponent: __jsx(ExternalLinkInput, {
      onConfirm: function onConfirm(data) {
        updateEntity(entityKey, _objectSpread(_objectSpread({}, data), {}, {
          editLink: false
        }), true);
      },
      focusOnMount: true,
      initialData: entityData
    }),
    linkPreview: __jsx(LinkURL, {
      href: generateClickableUrl(entityData.url),
      rel: entityData.attributes.rel,
      target: entityData.attributes.target
    }, generateDisplayableUrl(entityData.url))
  });
};

export default ExternalLink;